{
  "logoAlt": "Smart Word Labs",
  "footer": {
    "copyright": "© {{year}} Smart Word Labs · {{tagline}}"
  },
  "breadcrumb": {
    "home": "Home",
    "ariaLabel": "Breadcrumb"
  },
  "notifications": {
    "ariaLabel": "Notifications",
    "unreadMore": "9+",
    "title": "Alerts",
    "markRead": "Mark read",
    "new": "new",
    "empty": "No alerts yet.",
    "error": "Could not update notifications"
  },
  "mobileCta": {
    "bookFreeAssessment": "Book Free Assessment"
  }
}
